<div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
  <div [matTooltip]="date | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }">
    {{ date | date: 'dd.MM.yyyy' }}
  </div>
  <mat-icon [matTooltip]="user" class="cursor-help" svgIcon="avatar"></mat-icon>

  <!-- {{ serviceaftale.createdOn | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }} -->

  <!--
    <mat-icon
      *ngIf="serviceordre.serviceordreAfregning?.automaticApprovedForAccounting"
      [matTooltip]="serviceordre.modifiedBy + ' - Automatisk godkendt'"
      class="cursor-help"
      svgIcon="avatar-system"
    ></mat-icon>

    -->
</div>
